module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-03-25 at 7.55.31 pm.18539385.png";